import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables, getOnlyFileNameFromPath, getThemeSettingsVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable, truncateString} from '../../../common/Global/commonFunctions';
import * as TemplateConstants from "../../../common/Global/templateConstants";
import moment from 'moment';
import AddFollowUpTemplateValueDialog from "../Common/addFollowUpTemplateValueDialog";
import { TableIcon } from '../../../common/Global/globalStyles.style';

let themeSettings = getThemeSettingsVariables();
let userDetails = getLocalStorageVariables();

class FollowUpDetailsDialog extends Component {  
    constructor(props){
        super(props);
        this.state= {
            nextFollowUpDate : "",
            followUpTaskTemplateList:[],
            showFollowUpTemplateValueDialog:false,
            isEdit:false,
            followUpDetailsItem:this.props.followUpDetailsItem
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }
    
    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showFollowUpDetailsDialog){
            this.setState({
                followUpDetailsItem:this.props.followUpDetailsItem,
                assignmentTaskId:this.props.assignmentTaskId,
                observationId:this.props.observationId
            }, () => {
                this.getFollowUpBackups();
            })
        }
    }

    editFollowUpDetails = (value,version) => {
        this.getFollowupTaskTemplatevalues();
        this.setState({
            showFollowUpTemplateValueDialog:true,
            isEdit:true,
            value:value,
            version:version
        })
    }

    handleFollowUpTemplateValueDialogClose = (reloadFlag) => {
        this.setState({
            showFollowUpTemplateValueDialog:false,
            isEdit:false
        },() => {
            if(reloadFlag === true){
                this.getPreviousFollowUpTaskTemplateValues(this.props.assignmentTaskId,this.props.observationId)
            }
        })
    }
    
    taskEditable = () => {
        let taskItem = this.props.item;
        let endReviewUserId = "";
        for(var i=0;i<7;i++){
            if(taskItem.endReviewLevel===i){
                endReviewUserId=taskItem[`L${i}UserId`]
            }
        }
        if(!isEmptyVariable(endReviewUserId) && taskItem.currentReviewUserId==userDetails.userId && endReviewUserId==userDetails.userId){
            return false;
        }else{
            return !isEmptyVariable(taskItem.observationId)||taskItem.allowEdit==="N"?true:false  
        }
    }

    getFollowupTaskTemplatevalues = () => {
        this.setState({
			showLoader: true,
		});

        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            forDraft: true
        };

        if(!isEmptyVariable(this.props.observationId)){
            postParam.observationId = this.props.observationId
        }else{
            postParam.assignmentTaskId = this.props.assignmentTaskId
        }
        if(this.props?.isCompletedAuditee === true){
			postParam.forCompleted = true;
		}

        fetch(Constants.GetFollowUpTaskTemplateValues, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                let followUpTaskTemplateLists = data.data?.templateFields;
                let fixedTemplateFields = data.data?.fixedTemplateFields;
                if(!isEmptyVariable(this.props.observationId)){
                    this.setState({
                        observationId: this.props.observationId,
                    })
                }else{
                    this.setState({
                        assignmentTaskId: this.props.assignmentTaskId
                    })
                }
                this.setState({
                    followUpTaskTemplateList: followUpTaskTemplateLists,
                    fixedTemplateFields:fixedTemplateFields,
                    showLoader: false,
                })
            } else {
                this.setState({
                    showLoader: false,
                });
            }
        });
    }

    getPreviousFollowUpTaskTemplateValues = (assignmentTaskId,observationId) => {
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            forDraft: true
        }
        if(isEmptyVariable(observationId)){
            postParam.assignmentTaskId = assignmentTaskId;
        }else{
            postParam.observationId = observationId;
        }
        if(this.props?.isCompletedAuditee === true){
			postParam.forCompleted = true;
		}
        fetch(Constants.GetPreviousFollowUpTaskTemplateValues, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                const previousCheckAndOpen = data.data.previousCheckAndOpen;
                this.setState({
                    followUpDetailsItem:previousCheckAndOpen
                })
            } else {
                this.setState({
                    showFollowUpDetailsDialog:false
                });
            }
        });
    }

    downloadAttachment = (documentPath,e) => {
        e.stopPropagation();
        fetch(Constants.API_SERVER_PATH+documentPath)
        .then(response => {
            return response.blob();
        })
        .then(blob => {
            let fileName = getOnlyFileNameFromPath(documentPath);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    getFollowUpBackups = () => {
        this.setState({
            showLoader: true,
        });
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            forDraft: true
        }
        if(isEmptyVariable(this.state.observationId)){
            postParam.assignmentTaskId = this.state.assignmentTaskId;
        }else{
            postParam.observationId = this.state.observationId;
        }
        if(this.props?.isCompletedAuditee === true){
			postParam.forCompleted = true;
		}
        Promise.all([
            fetch(Constants.GetFollowUpBackups, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams(postParam),
            })
        ])
        .then(([followUpBackups]) => {
            return Promise.all([followUpBackups.json()]);
        })
        .then(([followUpBackups]) => {
            let followUpBackupsDataList = [];
    
            if(handleTokenExpiry(followUpBackups.responseCode)) return;
            else if (followUpBackups.responseCode === Constants.CODE_SUCCESS) {
                followUpBackupsDataList = followUpBackups.data.backups;
            } else {
            }
    
            this.setState({
                showLoader: false,
                componentDidMountFlag: true,
                followUpBackupsDatalist: followUpBackupsDataList
            });
        });
    };

    render() {
        const { followUpDetailsItem } = this.state;
        // Convert to array and sort by Date descending (latest first)
        const commentArr = !isEmptyArray(followUpDetailsItem) && Object.entries(followUpDetailsItem)
            .sort((a, b) => new Date(b[1][0].Date) - new Date(a[1][0].Date));

        // The first item after sort is the latest comment
        const latestKey = commentArr.length ? commentArr[0][0] : null;
        return(
            <div>
                <Modal className="custom-dialog followUp-dialog" show={this.props.showFollowUpDetailsDialog} onHide={this.props.handleFollowUpDetailsDialogClose}>
                    <Modal.Header>
                        <h5>Follow Up Details</h5>
                        <button 
                            onClick={this.props.handleFollowUpDetailsDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div class="modal-body">
                        <div className="details-table-layout">
                            <div className="row custom-row">
                                <div className="col-md-12 custom-col">
                                    <table>
                                        <tbody> 
                                            {
                                                !isEmptyArray(Object.keys(followUpDetailsItem)) ?
                                                Object.entries(followUpDetailsItem)?.map(([key, value]) => {
                                                    return(
                                                        <div className="m-t-15">
                                                            <div className="followup-heading-container">
                                                                <p className="followup-heading">Follow Up Details {key}</p>
                                                                <p className="followup-heading-name">Name: {value[0].userName}</p>
                                                                <p className="followup-heading">Date: {moment(value[0].Date).format("DD/MM/YYYY")}</p>
                                                                {   
                                                                    !this.props.item &&
                                                                    key === latestKey && // Only show edit icon for latest comment
                                                                    this.props.isFollowUpFreezed === "Y" &&
                                                                    <a onClick={()=>this.editFollowUpDetails(value,value[0].version)} href="javascript:void(0);">
                                                                        <span class="material-icons-outlined" 
                                                                        style={{
                                                                            color: `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                            opacity: "1",
                                                                            marginRight:22
                                                                        }}>edit</span>
                                                                    </a>
                                                                }
                                                            </div>
                                                            <div className="row custom-row">
                                                                <div className="col-md-12 custom-col">
                                                                    {value.map((item, index) => {
                                                                        return(
                                                                            <>
                                                                                <tr>
                                                                                    <td width={"38%"}>{item.fieldName}</td>
                                                                                    <td width={"4%"}>:</td>
                                                                                    <td width={"72%"}>
                                                                                        {
                                                                                            item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI?
                                                                                            !isEmptyArray(JSON.parse(item.value))?JSON.parse(item.value).join(", "):""
                                                                                            :item.value
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                                {index === 0 && !isEmptyVariable(item.nextFollowUpDate)&&
                                                                                    <>
                                                                                        <td  width={"38%"}>Next Follow Up Date</td>
                                                                                        <td  width={"4%"}>:</td>
                                                                                        <td  width={"72%"}>{!isEmptyVariable(item.nextFollowUpDate)?moment(item.nextFollowUpDate).format("DD/MM/YYYY"):""}</td>
                                                                                    </>
                                                                                }
                                                                                {!isEmptyArray(item.backupFiles) && 
                                                                                    <div style={{position:"relative"}}>
                                                                                        <h6 className="small-h6">
                                                                                            Supporting
                                                                                        </h6>
                                                                                        <div className="common-tab-bg">
                                                                                            <div className="common-table" style={{width:"100%"}}>
                                                                                                <table className="table">
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th className="text-center" width={"5%"}>No.</th>
                                                                                                            <th width={"5%"}>File Name</th>
                                                                                                            <th width={"5%"}>Remarks</th>
                                                                                                            <th className="text-center" width={"5%"}>Download</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                    {
                                                                                                        !isEmptyArray(item.backupFiles) && 
                                                                                                        item.backupFiles.map((item,idx) => {
                                                                                                            return !item.isDeleted?<tr>
                                                                                                                <td className="text-center">{(idx+1)}</td>
                                                                                                                <td>{getOnlyFileNameFromPath(item.documentPath)}</td>
                                                                                                                <td>{truncateString(item.remark,Constants.REMARKS_STRING_LENGTH)}</td>
                                                                                                                <TableIcon themeSettings={this.props.themeSettings} className="text-center">
                                                                                                                    <span class="material-icons" onClick={this.downloadAttachment.bind(this, item.documentPath)}>get_app</span>
                                                                                                                </TableIcon>
                                                                                                            </tr>
                                                                                                            :
                                                                                                            null
                                                                                                        })
                                                                                                    }
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className="dialog-no-records">
                                                    <p>{Constants.NO_RECORDS_WARNING}</p>
                                                </div>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                {
                    <AddFollowUpTemplateValueDialog
                        showFollowUpTemplateValueDialog={this.state.showFollowUpTemplateValueDialog}
                        handleFollowUpTemplateValueDialogClose={this.handleFollowUpTemplateValueDialogClose}
                        isEdit={this.state.isEdit}
                        themeSettings={themeSettings}
                        followUpTaskTemplateList={this.state.followUpTaskTemplateList}
                        backups={this.state.fixedTemplateFields?.backups}
                        assignmentTaskId={this.props.assignmentTaskId}
                        observationId={this.props.observationId}
                        assignmentId={this.props.assignmentId}
                        title={"Follow Up Details "+this.state.version}
                        value={this.state.value}
                    />
                }
            </div>
        );
    }
}

export default FollowUpDetailsDialog;